import { EVENT_TARGET } from '@vlabs/monokit/entities/events/api';
import type { EventListFilters } from '@vlabs/monokit/entities/events/filters';

export const WORKSPACE_DEFAULT_FILTERS: EventListFilters = {
  page_size: 30,
  order: 'desc',
  target: EVENT_TARGET as EventListFilters['target'],
};
